import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "_tc--error _mt-0" }
const _hoisted_2 = { class: "_flex" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_installment_state_box = _resolveComponent("installment-state-box")

  return (_openBlock(), _createBlock(_component_installment_state_box, {
    "payment-date": $props.paymentDate,
    "data-qa": "StretchPay:overdueInstallment"
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.InstallmentProgressOverdueTitle), 1 /* TEXT */)
    ]),
    value: _withCtx(() => [
      _createTextVNode(_toDisplayString($props.installmentValue), 1 /* TEXT */)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.Resources.YourPledge.InstallmentProgressOverdueDescription), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_tooltip, {
          text: $options.tooltipValue,
          enabled: $options.tooltipValue
        }, {
          default: _withCtx(() => [
            ($options.isRetryPaymentButtonVisible)
              ? (_openBlock(), _createBlock(_component_processing_button, {
                  key: 0,
                  width: "wide",
                  theme: "accent",
                  display: "block",
                  enabled: !$options.tooltipValue,
                  "is-processing": $data.isProcessing,
                  "is-action-in-progress": _ctx.isChargingInstallments,
                  status: $data.actionStatus,
                  onClick: $options.onRetryInstallmentPayment,
                  "data-qa": "StretchPay:retryPayment"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.RetryInstallmentButton), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["enabled", "is-processing", "is-action-in-progress", "status", "onClick"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["text", "enabled"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["payment-date"]))
}